<template>
  <div class="campsites-container">
    <v-layout row wrap>
      <v-flex align-content-space-between
              md4
              xs12
              v-if="paymentTrue !== undefined && paymentTrue !== null && paymentTrue.length > 0"
              v-for="camp in paymentTrue"
              :key="camp.public_id">
        <v-container fluid class="pa-2">
          <v-card flat hover class="campsite-card elevation-2">
            <router-link :to="{name: 'PFacility', params: {facility_id: camp.public_id}}">
              <v-img class="campsite-image"
                     :src="camp.thumbnail"
                     aspect-ratio="1.5"
                     gradient="to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.3)">
                <v-container fill-height class="pa-0">
                  <v-layout align-end class="image-overlay">
                    <v-flex xs12>
                      <span class="campsite-badge" v-if="camp.pricing_status === 'true'">
                        From {{$localCurrency}} {{$roundOff(convert1(camp.price[0].currency_type, camp.price[0].mandatory_price).amount)}}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-img>
            </router-link>

            <v-container fluid class="pt-3 pb-0">
              <router-link :to="{name: 'PFacility', params: {facility_id: camp.public_id}}"
                           class="text-decoration-none">
                <h3 class="campsite-title earthwerk-font">{{(camp.name).toUpperCase()}}</h3>
              </router-link>

              <div class="campsite-details mt-2">
                <span v-if="camp.pricing_status === 'true'">
                  <div class="price-info">
                    <div class="price-pack">
                      <span>Base Price: </span>
                      <span>{{$localCurrency}} {{$roundOff(convert1(camp.price[0].currency_type, camp.price[0].mandatory_price).amount)}} (exclusive of night charges)</span>
                    </div>
                    <div class="price-pack">
                      <span>Range: </span>
                      <span>{{$localCurrency}} {{$roundOff(convert1(camp.price[0].currency_type, camp.price[0].child_price).amount)}} - {{$localCurrency}} {{$roundOff(convert1(camp.price[0].currency_type, camp.price[0].adult_price).amount)}}</span>
                    </div>
                  </div>
                </span>
                <span v-else>
                  {{camp.pricing}}
                </span>
              </div>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="paymentTrue === undefined || paymentTrue === null || paymentTrue.length === 0">
      <v-flex lg4 md12 xs12 sm12 v-for="n in 3" :key="n">
        <v-container fluid class="pa-2">
          <v-card class="elevation-2">
            <v-container>
              <content-placeholders :rounded="true">
                <content-placeholders-img />
                <content-placeholders-heading />
              </content-placeholders>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  export default {
    name: 'camp-sites',
    data() {
      return {}
    },
    created() {
      this.$store.dispatch('get_active_camping')
    },
    methods: {
      facilityImage: function (image) {
        return 'http://178.79.164.219:8000/var/www/html/opc_services/' + image
      }
    },
    computed: {
      paymentTrue: function () {
        var activeInventory = []
        this.allCampsites.map(function (data) {
          if (data.pricing_status === 'true' && data.thumbnail !== null) {
            activeInventory.push(data)
          }
        })
        return activeInventory
      }
    }
  }
</script>

<style scoped>
  @font-face {
    font-family: 'Earthwerk';
    src: url('PizzaDude.dk-Earthwerk.otf');
    font-weight: normal;
    font-style: normal;
  }

  .campsites-container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .campsite-card {
    border-radius: 8px !important;
    transition: all 0.3s ease;
    overflow: hidden;
  }

    .campsite-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
    }

  .campsite-image {
    border-radius: 8px 8px 0 0 !important;
    transition: transform 0.5s ease;
    overflow: hidden;
  }

  .campsite-card:hover .campsite-image {
    transform: scale(1.05);
  }

  .image-overlay {
    padding: 16px;
  }

  .campsite-badge {
    background-color: rgba(116, 165, 51, 0.9);
    color: white;
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 14px;
    font-weight: 600;
    display: inline-block;
  }

  .earthwerk-font {
    font-family: 'Earthwerk', sans-serif;
    color: #333;
    font-size: 20px;
    line-height: 1.3;
    margin-bottom: 8px;
    letter-spacing: 0.5px;
  }

  .campsite-title {
    transition: color 0.2s ease;
  }

    .campsite-title:hover {
      color: #74a533 !important;
    }

  .price-info {
    color: #666;
    font-size: 14px;
  }

  .price-pack {
    margin-bottom: 6px;
  }

    .price-pack span:last-child {
      color: #e67e22;
      font-weight: 600;
    }

  .campsite-details {
    border-top: 1px solid #eee;
    padding-top: 12px;
  }

  @media (max-width: 960px) {
    .earthwerk-font {
      font-size: 18px;
    }
  }

  @media (max-width: 600px) {
    .campsite-card {
      margin-bottom: 16px;
    }

    .earthwerk-font {
      font-size: 16px;
    }
  }
</style>
